// extracted by mini-css-extract-plugin
export default {"confirm":"style_confirm__mbL1Q","icon":"style_icon__+VWoW","select":"style_select__4uB7p","label":"style_label__B5jiF","accept":"style_accept__G2OJw","cancel":"style_cancel__b75Hx"};